<template>
  <a v-if="show" id="hard-limit-counter" :class="classObject" data-testid="hard-limit-counter">
    <span class="label">
      FREE UPLOADS:
    </span>
    &nbsp;
    <div class="drops-used">
      <span>
        {{userDropsCount}}
      </span>
      <span class="slash">
        /
      </span>
      <span>
        {{limit}}
      </span>
    </div>
    <b-tooltip
      target="hard-limit-counter"
      v-if="userDropsCount >= limit"
      trigger="hover focus"
      title="Upload limit reached. Upgrade to unlock."
    ></b-tooltip>
  </a>
</template>

<script>
import featureKey from "../../feature_key.macro";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      limit: state => state.features?.[featureKey("hard-limit-drops")] || -1,
      freeOrg: state => state.currentOrganization.attributes.free,
      userDropsCount: state => state.user?.attributes?.item_count || 0,
      overlapButton: state => state.features?.[featureKey("upgrade-button-dashboard-viewer")],
      currentUser: state => state.user
    }),
    show: function() {
      return this.limit !== -1 && this.freeOrg;
    },
    classObject: function() {
      return {
        "shift-right": this.overlapButton,
        "limit-reached": this.userDropsCount >= this.limit,
      };
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/packs/application.scss";

a {
  display: flex;
  flex-flow: row nowrap;
  border-radius: 4px;
  border-radius: 4px;
  border: solid 0.5px #d0d0d0;
  padding: .4rem .8rem;
  font-size: .75rem;
  font-weight: bold;
  font-family: SFPro;
  position: relative;

  .label {
    color: #828282;
  }

  .drops-used {
    color: $dark-gray;
  }
}

.shift-right {
  padding-right: 1.8rem;
  left: 1rem;
}

a.limit-reached {
  .drops-used {
    color: $grapefruit;
  }

  .slash {
    color: $dark-gray;
  }
}

a:hover {
  text-decoration: none;
  cursor: pointer;
}
</style>
